import { render } from "./AdminHeader.vue?vue&type=template&id=5b0d3f3b&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"

import "./AdminHeader.vue?vue&type=style&index=0&id=5b0d3f3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0d3f3b"]])

export default __exports__